export default __webpack_public_path__ + "static/media/emma-video-poster.1dd9c47a.png";